import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconSend = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconSend.dimensions.width} ${IconSend.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
        fill={color || Color.premiumBlack}
        fillRule="nonzero"
      />
    </Svg>
  )
}

IconSend.dimensions = {
  width: 24,
  height: 24,
}

export default IconSend
